/**
 * Generic segmented toggle with the same look as PeriodToggle (controls.tsx),
 * for non-period choices such as New logo / Expansion.
 */
export function SegmentToggle<T extends string>({
  value,
  onChange,
  options,
  label,
}: {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: string }[];
  label: string;
}): React.JSX.Element {
  return (
    <div role="radiogroup" aria-label={label} className="inline-flex rounded-md border border-ink-200 bg-ink-50 p-0.5">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => {
            onChange(o.value);
          }}
          className={`rounded px-2 py-0.5 text-[0.68rem] font-medium transition-colors ${
            value === o.value ? 'bg-white text-ink-900 shadow-sm' : 'text-ink-500 hover:text-ink-900'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
